
import React from 'react';
import { config } from "util/config";

const CustomEmpty = ({

}) =>
  <>No records</>;
export default CustomEmpty;
